import { StochasticInvoice } from "@/api/fetchStochasticInvoices/types";
import { formatCurrency } from "@/utils/formatCurrency";
import { Column } from "@/components/Datatable/types";

export function createInvoicesColumns(): Column<StochasticInvoice>[] {
  return [
    {
      header: "Invoice ID",
      accessorKey: "id",
      enableSorting: true,
    },
    {
      header: "Invoice Number",
      accessorKey: "invoiceNumber",
      enableSorting: true,
      cell: ({ row }) => row.original.invoiceNumber || "N/A",
    },
    {
      header: "Customer Name",
      accessorKey: "customerName",
      enableSorting: true,
    },
    {
      header: "Invoice Date",
      accessorKey: "invoicedAt",
      enableSorting: true,
      cell: ({ row }) =>
        row.original.invoicedAt
          ? new Date(row.original.invoicedAt).toLocaleDateString()
          : "N/A",
    },
    {
      header: "Total",
      accessorKey: "total",
      enableSorting: true,
      cell: ({ row }) => formatCurrency(row.original.total),
    },
  ];
}
